import rifaService from '../services/rifa.service';

/**
 * Downloads a rifa ticket PDF preview (isPreview=true on the server).
 */
export async function downloadRifaTicketPreview(rifaId) {
  const data = await rifaService.downloadTicketPreview(rifaId, { isPreview: true });
  const blob = new Blob([data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'preview.pdf';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
